import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from "react-hook-form";

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label?: string;
  placeholder?: string;
  type?: string;
}

export function ControlledInput<T extends FieldValues>({
  control,
  name,
  label,
  placeholder = "",
  type = "text",
}: Props<T>) {
  const { field } = useController({ control, name });
  // const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   onChange?.(e.target.value);
  // };

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label style={{ fontSize: "14px", fontWeight: "bold" }}>{label}</label>
      )}

      <input
        type={type}
        placeholder={placeholder}
        // onChange={handleChange}
        {...field}
        style={{
          display: "block",
          width: "90%",
          padding: "10px",
          marginTop: "5px",
          background: "#f0f3fc",
          marginBottom: "15px",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      />
    </div>
  );
}
